<template>
	<div>
		<div class="top">
			<div class="videoleft">
				<img @click="toback()" src="../../assets/img/video/ico_fh.svg" alt="" />
				{{ chaptername }}
			</div>
			<div class="videoright">
				<img src="../../assets/img/index/course.jpg" alt="" />
				<!-- 文文跑江湖 -->
			</div>
		</div>

		<body>
			<div id="J_prismPlayer"></div>
		</body>

		<!-- <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player> -->

		<!-- 侧边选择栏 -->
		<div class="rightlist" :style="{ right: posRight + 330 + 'px' }">
			<div class="list" v-for="(item, index) in list" @click="toleft(index)" :key="index"
				:class="{ actlist: rightIndex == index }">
				<img v-if="rightIndex == index" :src="item.img1" alt="" />
				<img v-else :src="item.img" alt="" />
				{{ item.name }}
			</div>
		</div>
		<!-- 侧边弹出框 -->
		<div class="openright" :style="{ right: posRight + 'px' }">
			<video-list v-if="rightIndex == 0" :videos="chapters" :bjkey='id' @select="handleSelect"
				class="videoList"></video-list>
			<!-- 课程目录 -->
			<!-- <div class="courlist" v-if="rightIndex == 0">
                <div class="title">第一章 解锁建筑设计诀窍</div>
                <div class="video" v-for="(item, index) in video" :key="index" @mouseover="avtvideo(index)" :class="{ backg: index === i }" @click="tovideo()">
                    <div>
                        <img v-if="i === index" src="../../assets/img/course/play_action.svg" alt="" />
                        <img v-else src="../../assets/img/course/play.svg" alt="" />
                        <div class="tiitle">{{ item.tiitle }}</div>
                    </div>
                </div>
            </div> -->
		</div>
	</div>
</template>

<script>
	//导出aliplayer

	// 导出样式
	import {
		queryVideoUrl,
		updateVideoUpdateTime,
		getStudyHistoryByChapterId
	} from '@/api/chapter.js';
	import {
		Notification,
		MessageBox,
		Message,
		Loading
	} from 'element-ui';

	export default {
		data() {
			return {

				text: '',
				i: 0,
				chaptername: '',
				screenHeight: 0,
				posRight: -325,
				list: [{
					img: require('../../assets/img/video/player_icon_4.svg'),
					img1: require('../../assets/img/video/player_icon_1_action.svg'),
					name: ' 章节列表'
				}, ],
				video: [{
						tiitle: '【回放】卸料平台坍塌风险预测学习（2021/10/28 14:30-16:39）',
						play: '可回放',
					},
					{
						tiitle: '【回放】卸料平台坍塌风险预测学习（2021/10/28 14:30-16:39）',
						play: '可回放',
					},
					{
						tiitle: '【回放】卸料平台坍塌风险预测学习（2021/10/28 14:30-16:39）',
						play: '可回放',
					},
				],
				chartArr: [{
					con: '自己的1'
				}],
				rightIndex: '',
				id: '',
				url: '',
				videoId: '',
				start_time: '0',
				update_time: '0',
				chapters: [],
				play_index: '',
				time: 0,
				hisId: null,
				timestamp: null,
			};
		},
		mounted() {
			this.id = this.$route.query.id;
			this.videoId = this.$route.query.videoId;
			this.chaptername = this.$route.query.name;
			this.play_index = this.$route.query.index;
			var params = {
				id: this.id,
				videoId: this.videoId,
				year: localStorage.getItem('year')
			};


			queryVideoUrl(params).then(res => {
				//查询到历史记录hisId
				this.hisId = res.data.his;
				this.timestamp = res.data.timestamp;
				this.startVideo(this.id, res.data.url);
				console.log(res.data.url)
				/* this.videos.unshift({
				    id: 0,
				    name: '引言',
				    url: res.data.url,
				    disablied: true,
				}); */
				//this.playerOptions.sources[0].src = res.data.url;
			});
			this.chapters = JSON.parse(localStorage.getItem('chapters'));
			console.log('this.chapters:', this.chapters)
			//alert(JSON.stringify(this.chapters));
		},
		created() {
			this.id = this.$route.query.wid;
		},
		methods: {
			startVideo(chapterId, url) {
				var me = this;
				var params = {
					chapterId: chapterId,
					year: localStorage.getItem('year')
				}
				this.player = window.Aliplayer({
						id: 'J_prismPlayer',
						width: '100%',
						height: '100%',
						videoHeight: '80vh',
						source: url, //视频的播放凭证，可以在通用媒体管理服务控制台获取。
					},
					function(player) {
                        var updateStudyTime = {
                        	hisId: me.hisId,
                        	year: localStorage.getItem('year'),
                        	chapterId: me.id,
                        	timeLength: player.getDuration(),
                        	havePlayTime: player.getCurrentTime(),
                        	timestamp: me.timestamp
                        }
						player.on('ended', () => {
							var currentTime = player.getCurrentTime();
							console.log(player.getDuration());
							console.log(player.getCurrentTime());
							//var time = Math.trunc(currentTime);
							updateVideoUpdateTime(updateStudyTime).then(res => {
								if (res.code == 200 && res.state == '1') {
									me.update_time = res.history.readTimeLength;
								} else if (res.code == 200 && res.state == '0') {
									me.$message.error(res.msg);
									me.player.seek(res.history.readTimeLength);
									return;
								} else if (res.code == 200 && res.state == '9') {
									//me.$message.error(res.msg);
									me.player.pause();
									alert("本章节已学完")
									/* me.$confirm(res.msg, '警告提示', {
										distinguishCancelAndClose: true,
										type: 'warning ',
										confirmButtonText: '继续学习',
										cancelButtonText: '关闭'
									}).then(() => {
										//继续学习
										location.reload();
										//alert("试学！");
									}).catch(action => {
										console.log("取消所属")
									}); */
									return;
								}
								//this.playerOptions.sources[0].src = res.data.url;
							});
							/* var arr = me.play_index.split(',');
						if(arr.length > 1){
							 //如果存在章节、则判断子章节是否有下个章节
							 var idex0 = arr[0];
							 var idex1 = arr[1];
							 var subchapterlist = me.chapters[idex0].subCourseChapterList;
							 //如果有
							if(subchapterlist.length >(idex1 +1 )){ 
								var video1 = me.chapters[idex0].subCourseChapterList[idex1+1] ;
								var bj1 = idex1 + 1;
								me.handleSelect(video1,  (idex0 +',' +idex1));
							}else{
								var bj2 = idex0 + 1;
								var video2 = me.chapters[bj2].subCourseChapterList[0];
								me.handleSelect(video2,(bj2 +',' + '0'));
							}
						}else{
							var bj3 = arr[0] + 1;
							var video3 = me.chapters[bj3];
							if(video3.subCourseChapterList){
								me.handleSelect(video3.subCourseChapterList[0],  (bj3 +',0'));
							}else{
								me.handleSelect(video3,bj3);
							}
						} */

						});
						player.on('timeupdate', () => { // 播放位置发生改变时触发，仅H5播放器。
							var currentTime = player.getCurrentTime();
							console.log(player.getDuration());
							console.log(player.getCurrentTime());
							var time = Math.trunc(currentTime);

							if ((time % 23) == 0 && this.time != time) {
								this.time = time;
								//alert(localStorage.getItem('year'));
								var updateStudyTime = {
									hisId: me.hisId,
									year: localStorage.getItem('year'),
									chapterId: me.id,
									timeLength: player.getDuration(),
									havePlayTime: player.getCurrentTime(),
									timestamp: me.timestamp
								}
								updateVideoUpdateTime(updateStudyTime).then(res => {
									if (res.code == 200 && res.state == '1') {
										me.update_time = res.history.readTimeLength;
									} else if (res.code == 200 && res.state == '0') {
										me.$message.error(res.msg);
										me.player.seek(res.history.readTimeLength);
										return;
									} else if (res.code == 200 && res.state == '9') {
										//me.$message.error(res.msg);
										me.player.pause();
										me.$confirm(res.msg, '警告提示', {
											distinguishCancelAndClose: true,
											type: 'warning ',
											confirmButtonText: '继续学习',
											cancelButtonText: '关闭'
										}).then(() => {
											//继续学习
											location.reload();
											//alert("试学！");
										}).catch(action => {
											console.log("取消所属")
										});

										return;
									}
									//this.playerOptions.sources[0].src = res.data.url;
								});
							}
						});
					}
				);

				getStudyHistoryByChapterId(params).then(res => {
					if (res.code == 200) {
						if (res.history.readTimeLength != null && res.history.readTimeLength != '') {
							//me.start_time = res.history.readTimeLength;
							me.player.seek(res.history.readTimeLength);
						} else {
							me.start_time = '0'
							return;
						}
					} else {
						me.$message.error('网络超时');
						return;
					}
				});

				this.player.play();
			},
			handleSelect(video, index) {
				debugger;
				this.play_index = index;
				if (video.type == 'ml') {
					return;
				}
				this.$router.push({
					path: '/course/video',
					query: {
						id: video.id,
						videoId: video.sourceUrl,
						name: video.chapterName,
						year: localStorage.getItem('year'),
					}
				});
				location.reload();
				/* if (!video.disablied) {
				    this.player.loadByUrl(video.url);
				}
				this.videos.forEach(i => {
				    i.disablied = i === video;
				}); */
			},

			toleft(index) {
				if (index === this.rightIndex) {
					this.posRight = this.posRight < 0 ? 0 : -325;
				} else {
					this.posRight = 0;
				}
				this.rightIndex = index;
			},
			toback() {
				this.$router.back(-1);
			},
			tosend() {
				console.log(this.text);
				if (!this.text) {
					return this.$toast('请输入内容');
				}
				this.chartArr.push({
					con: this.text
				});
				this.text = '';
			},
			avtvideo(i) {
				this.i = i;
			},
		},
	};
</script>

<style lang="less" scoped>
	.videoList {}

	.top {
		height: 70px;
		background: #383838;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 40px;

		.videoleft {
			font-size: 20px;
			color: #ffffff;
			vertical-align: middle;

			img {
				cursor: pointer;
				width: 15px;
				height: auto;
				vertical-align: middle;
				margin-right: 25px;
			}
		}

		.videoright {
			img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				border: 1px solid #707070;
				margin-right: 13px;
				vertical-align: middle;
			}

			vertical-align: middle;
			font-size: 16px;
			color: #ffffff;
		}
	}

	.video-player {
		// position: relative;
	}

	// 侧边选择栏
	.rightlist {
		position: fixed;
		right: 5px;
		top: 50%;
		transform: translate(0, -50%);
		transition: 0.5s;

		.list {
			img {
				width: 20px;
				height: auto;
				margin: 0 auto;
				display: block;
				padding-top: 20px;
				margin-bottom: 5px;
			}

			text-align: center;
			width: 30px;
			height: auto;
			background: #383838;
			padding:0 8px 15px 12px;
			text-align: center;
			font-size: 16px;
			color: #ffffff;
			margin-top: -10px;
			cursor: pointer;
			border-radius: 20px 0 0 20px;

		}

		.actlist {
			background: #2961ef;
		}
	}

	// 侧边弹出框
	.openright {
		position: fixed;
		right: -325px;
		top: 0;
		bottom: 0;
		width: 325px;
		transition: 0.5s;
		z-index: 11;

		background: rgba(0, 0, 0, .8);
		backdrop-filter: blur(5px) brightness(110%);
		-webkit-backdrop-filter: blur(5px) brightness(110%);
		border-left: 7px solid #2961ef;

		.topbox {
			padding: 18px 11px;

			.openbox {
				margin-bottom: 22px;

				img {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					display: inline-block;
					vertical-align: top;
					margin-right: 10px;
				}

				.img1 {
					margin-left: 10px;
				}

				.rightcont {
					display: inline-block;

					.name {
						font-size: 14px;
						color: #cccccc;
						margin-bottom: 3px;
					}

					.ourname {
						text-align: right;
					}

					.content {
						width: 210px;
						background: #5a5a5a;
						border-radius: 10px 10px 10px 10px;
						padding: 13px;
						font-size: 16px;
						color: #d1d1d1;
						position: relative;

						img {
							display: block;
							width: 12px;
							height: auto;
							position: absolute;
							left: -10px;
							top: 15px;
						}
					}

					.ourcont {
						background: #ee7112;
						border-radius: 10px 10px 10px 10px;
						font-size: 16px;
						color: #ffffff;

						img {
							display: block;
							width: 12px;
							height: auto;
							position: absolute;
							left: 233px !important;
							top: 15px !important;
						}
					}
				}
			}
		}

		.bottom {
			box-shadow: 0px -3px 20px 1px rgba(241, 241, 241, 0.21176470588235294);
			padding: 18px;
			position: absolute;
			bottom: 0;
			right: 0;
			left: 0;

			textarea {
				width: 96%;
				height: 100px;
				padding: 10px;
				background: #ffffff;
				border-radius: 6px 6px 6px 6px;
				border: 1px solid #707070;
			}

			.submit {
				cursor: pointer;
				margin: 20px auto 0;
				width: 142px;
				height: 37px;
				line-height: 37px;
				text-align: center;
				background: #2961ef;
				border-radius: 27px 27px 27px 27px;
				font-size: 16px;
				color: #ffffff;
			}
		}

		.courlist {
			padding: 0 30px;

			.title {
				padding-left: 10px;
				line-height: 20px;
				font-size: 20px;
				font-weight: 300;
				color: #cccccc;
				border-left: 7px solid #2961ef;
				margin: 30px 0 20px;
			}

			.backg {
				background: rgba(250, 250, 250, 1);
			}

			.video {
				width: 100%;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1px solid rgba(112, 112, 112, 0.14);
				padding: 0 22px;
				height: 50px;

				img {
					width: 20px;
					height: auto;
					margin-right: 5px;
					display: inline-block;
					vertical-align: middle;
				}

				.tiitle {
					display: inline-block;
					vertical-align: middle;
					font-size: 16px;
					width: 55%;
					font-weight: 300;
					color: #999999;
					overflow: hidden;
					height: 50px;
					line-height: 50px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.plan {
					margin-left: 300px;
					font-size: 16px;
					color: #2961ef;
				}

				.right {}
			}
		}
	}

	.prism-player {
		height: calc(100vh - 72px) !important;
		overflow: hidden;
	}
</style>